export default __webpack_public_path__ + "ddada15c2cd2f016ef9945f186d5c62f.svg";